import { INVENTORY_PAGE } from "routes/route.constant";
import Inventory from "./Inventory";

const route = {
  path: INVENTORY_PAGE,
  element: Inventory,
};

export default route;
